<!--Modals-->
<ui-dialog
    #createStatHolidayModal
    formDialog
    header="{{ 'time-off-v3.selectCountryAndRegion' | translate }}"
    size="small"
    (primaryButtonPressed)="prefillHolidays()"
    (secondaryButtonPressed)="hideCreateStatHolidayModel()"
    [open]="isStatHolidayModalOpen"
    (closing)="hideCreateStatHolidayModel()"
>
    <p>{{ 'time-off-v3.selectWhichCountryAndRegionsStatHolidays' | translate: { year } }}</p>
    <app-create-stat-holiday-form #createStatHolidayForm [year]="year"></app-create-stat-holiday-form>
</ui-dialog>

<app-deprecated-modal-form
    #holidayModal
    [form]="holidayForm"
    (save)="onHolidaySave(holidayForm)"
    headerText="{{ headerText | appTranslate }}"
>
    <app-holiday-form #holidayForm></app-holiday-form>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #holidayDeleteModal
    header="{{ 'time-off-v3.deleteHoliday' | translate }}"
    description="{{ 'time-off-v3.areYouSureYouWantToDeleteThisHoliday' | translate }}"
    label="{{ 'time-off-v3.delete' | translate }}"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #copyCustomHolidaysModal
    header="{{ 'time-off-v3.copyCustomHolidays' | translate }}"
    description="{{
        'time-off-v3.areYouSureYouWantToCopyTheCustomHolidaysFromYearToYear'
            | translate: { previousYear: year - 1, currentYear: year }
    }}"
    label="{{ 'time-off-v3.save' | translate }}"
>
</app-deprecated-confirmation-dialog>

<!--Form-->
<form #form="ngForm">
    <!--    Table-->
    <div class="table-wrapper">
        <app-table
            *ngIf="holidaysTable"
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="holidaysTable"
            [showOffset]="false"
            (menuItemSelected)="menuAction($event, holidayForm)"
            [showPagination]="false"
            [class.time-off-improvement]="hasTimeOffImprovement"
            title="{{ 'time-off-v3.holidays' | translate }}"
        >
            <div class="buttons">
                <ui-button
                    type="{{ hasTimeOffImprovement ? 'outline' : 'link' }}"
                    (click)="showCreateStatHolidayModel()"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.addStatHolidays' | translate }}</ui-button
                >
                <ui-button
                    type="{{ hasTimeOffImprovement ? 'outline' : 'link' }}"
                    (click)="showCreateCustomHolidayModal(holidayForm)"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.addCustomHoliday' | translate }}</ui-button
                >
            </div>
            <div class="empty empty-state-wrapper">
                <h2 class="ui centered header">{{ 'time-off-v3.noHolidaysSavedForYear' | translate: { year } }}</h2>
                <ui-button type="primary" (click)="onCopyCustomHolidays(year)">
                    <mat-icon svgIcon="calendar" class="margin-right-1"></mat-icon
                    >{{ 'time-off-v3.copyHolidaysFromPreviousyear' | translate }}</ui-button
                >
            </div>
        </app-table>
    </div>
</form>
